export default {
    headers: {
        line1: "JCB Thailand",
        line2: "Join to JCB Thailand"
    }
}
